import { Col, Container, Form, Row } from 'react-bootstrap';
import React, { useState } from 'react';

import { Base64 } from 'js-base64';
import Pako from 'pako';
import StackTraceDisplay from './StackTraceDisplay';

const StackTraceDecoder = () => {
  const [stackTraceEncodedText, setStackTraceEncodedText] = useState('');
  const [stackTraceDecodedText, setStackTraceDecodedText] = useState('');

  const setNewStackTraceEncodedText = newInput => {
    setStackTraceEncodedText(newInput);
    processStackTrace(newInput);
  };

  const processStackTrace = input => {
    const indexOfColon = input.indexOf(':');
    if (indexOfColon > -1) {
      input = input.substring(indexOfColon + 1);
    }
    input = input.trim();

    let stackTrace = '';
    try {
      stackTrace = ungzip(input, 2);
    } catch (e) {
      setStackTraceDecodedText('Bad input, try again.');
      return;
    }

    setStackTraceDecodedText(stackTrace);
  };

  const ungzip = (input, times) => {
    let result = input;
    for (let i = 0; i < times; i++) {
      // step 1: decode result from base64 to bytes
      const bytes = Base64.toUint8Array(result);
      // step 2: unzip
      const inflated = Pako.inflate(bytes);
      // step 3 create a string out of bytes and store in result
      result = new TextDecoder('utf-8').decode(inflated);
    }

    return result;
  };

  return (
    <Container fluid>
      <Row>
        <Col>
          <Form.Label>Decode base64 gzipped stack traces that StackTraceReducer produces.</Form.Label>
        </Col>
      </Row>
      <Row>
        <Col>
          <Form.Control
            placeholder="Paste base64 stack trace here"
            as="textarea"
            rows="1"
            value={stackTraceEncodedText}
            onChange={e => setNewStackTraceEncodedText(e.target.value)}
          />
        </Col>
      </Row>
      <Row>
        <Col>
          <StackTraceDisplay text={stackTraceDecodedText} />
        </Col>
      </Row>
    </Container>
  );
};

export default StackTraceDecoder;
